import { NameDto } from '../../Common/Types'

export interface IntroducingBrokerDto {
  Id: string
  Name: string
  Client: {
    name: string | null
    introducingBroker: NameDto
    TickmillCompany: TickmillCompanyIBDto
    Teams: TeamIBDto[]
  }
  IntroducingBrokerProfile: IntroducingBrokerProfile
  MultiLevelCommission: MultiLevelCommission
  IntroducingBrokerStatus: string
}

export enum IntroducingBrokerKey {
  Id = 'Id',
  Name = 'Name',
  Client = 'Client',
  clientName = 'client.name',
  Country = 'Country',
  TickmillCompany = 'TickmillCompany',
  Teams = 'Teams',
  IntroducingBrokerProfile = 'IntroducingBrokerProfile',
  MultiLevelCommission = 'MultiLevelCommission',
  IntroducingBrokerStatus = 'IntroducingBrokerStatus',
  ShortName = 'ShortName',
  Team = 'Team',
  StandardCommissions = 'StandardCommissions',
  InstrumentCommissions = 'InstrumentCommissions',
  AccountType = 'AccountType',
  Amount = 'Amount',
  Instrument = 'Instrument',
  Percentage = 'Percentage',
  RegisteredAt = 'RegisteredAt',
}

interface TickmillCompanyIBDto {
  ShortName: string
  Name: string
}
interface TeamIBDto {
  Team: string
}
interface IntroducingBrokerProfile {
  Id: string
  Name: string
  StandardCommissions: StandardCommissionDto[]
  InstrumentCommissions: StandardInstrumentCommissionDto[]
}

interface StandardCommissionDto {
  AccountType: string
  Amount: number
}

interface StandardInstrumentCommissionDto {
  AccountType: string
  Instrument: string
  Amount: number
}
interface MultiLevelCommission {
  Id: string
  Percentage: number
  RegisteredAt: string
}

export enum IntroducingBrokerNetworkKey {
  subIBAccount = 'introducingBroker',
  level = 'level',
  IBProfile = 'commissionPlanGroup.name',
  numberOfClients = 'numberOfClients',
}
